import React, { useState, useEffect } from "react";
import { history } from "../../_helpers";
import { userActions } from "../../_actions";
import { useDispatch, useSelector } from "react-redux";

///module Imports
import { useTranslation } from "react-i18next";

import AOS from "aos";
import "aos/dist/aos.css";

import { Router, Switch, Route, Link } from "react-router-dom";

//navbar import
import Navbar from "./navbar/Navbar";

//404 not found page
import Error404 from "./Error404";

import MemberList from "./MemberList";
import StudentsList from "./student/StudentsList";
import { Loading } from "../Other/Loading";
import "../Dashboard/dashboard.scss";
import Dashboard from "./Dashboard";
import Announcement from "./Instructor/Announcement";
import ViewAward from "./Teachers/Awards/ViewAward";
import CourseList from "./Teachers/CourseList";
import QuizResult from "./Admin/QuizResult";
import CreateBundle from "./Teachers/CreateCourse/CreateBundle";
import StudentAchievements from "./student/achievements/Achievements";
import StudentAnnouncement from "./student/announcement/Announcement";
import wishlist from "./student/wishlist/wishlist";
import WebinarEvents from "./student/webinar/WebinarEvents";
import StudentNotes from "./student/notes/Notes";
import StudentForum from "./student/forum/Forums";
import StudentResult from "./student/results/Results";
import "./Teachers/CreateCourse/CourseQuestion/CourseBuilder.scss";
import Subscription from "./Subscription/Subscription";
import CreateCourse from "./Teachers/CreateCourse/CreateCourse";
import TeacherReport from "./Teachers/MemberList/TeacherReport";
import MonthReport from "./Teachers/MemberList/MonthReport";
import CourseReport from "./Teachers/MemberList/CourseReport";
import PaymentReport from "./Teachers/MemberList/PaymentReport";
import StudentData from "./Teachers/MemberList/StudentData";
import BundleList from "./Teachers/BundleList";
import CourseBuilder from "./Teachers/CreateCourse/CourseQuestion/CourseBuilder";
import CoursesContainer from "./student/CoursesContainer";
import Profile from "./profileManager/Profile";
import CourseDetail from "./CourseData/CourseDetali";
import CourseEdit from "./Teachers/CreateCourse/CourseQuestion/CourseBuilderComponents/CourseEdit/CourseEdit";
import PrivateRoute from "../PrivateRoute";
import Cart from "./ShoppingCart/Cart";
import AllCategories from "./AllCategories";

export default function Main(props) {
  const dispatch = useDispatch();
  const { user } = useSelector((state) => state.users);

  const [value, setValue] = useState(
    window.localStorage.getItem("tabsvalue")
      ? parseInt(window.localStorage.getItem("tabsvalue"))
      : 0
  );
  const { t } = useTranslation();
  const [showIconsOnly, setShowIconsOnly] = useState(false);
  const [dropdownToggle, setDropdownToggle] = useState(false);
  useEffect(() => {
    function tr() {
      AOS.init({ duration: 750, easing: "ease-in-quad" });
    }
    tr();
  });

  useEffect(() => {
    dispatch(userActions.getUserInfo());
  }, []);

  if (!user) {
    return <Loading />;
  }

  const enterpriseMenu = [
    {
      label: t("sideMenu.dashboard"),
      icon: "icon icon-home",
      url: "/dashboard",
      component: Dashboard,
    },
    {
      label: t("Instructor List"),
      icon: "icon icon-instructors",
      url: "/dashboard/instructorList",
      component: MemberList,
    },
    {
      label: t("Students List"),
      icon: "icon icon-students",
      url: "/dashboard/studentList",
      component: StudentsList,
    },
    {
      label: t("Quiz Result"),
      icon: " icon icon-award",
      url: "/dashboard/QuizResult",
      component: QuizResult,
    },
    {
      label: t("All Courses"),
      icon: "icon icon-video",
      url: "/dashboard/Course",
      component: CourseList,
    },
    {
      label: t("Create a Bundle"),
      icon: "icon icon-video",
      url: "/dashboard/CreateBundle",
      component: CreateBundle,
    },
    {
      label: t("sideMenu.createCourse"),
      icon: "icon icon-courses",
      url: "/dashboard/CourseBuilder",
      component: CreateCourse,
    },
    {
      label: "Announcement",
      icon: "icon icon-award",
      url: "/dashboard/Announcement",
      component: Announcement,
    },

    {
      label: t("Reports"),
      icon: "icon icon-courses",
      innerComponents: [
        {
          label: t(" Detail for Student"),
          icon: "icon icon-courses",
          url: "/dashboard/studentdata",
          component: StudentData,
        },
        {
          label: t("Detail  For Courses"),
          icon: "icon icon-courses",
          url: "/dashboard/coursreport",
          component: CourseReport,
        },
        {
          label: t("Month Wise Report"),
          icon: "icon icon-courses",
          url: "/dashboard/monthreport",
          component: MonthReport,
        },
        {
          label: t("Detail For Teachers"),
          icon: "icon icon-courses",
          url: "/dashboard/teacherreport",
          component: TeacherReport,
        },
        {
          label: t("MonthWise Payment Report"),
          icon: "icon icon-courses",
          url: "/dashboard/paymentreport",
          component: PaymentReport,
        },
      ],
    },
    {
      label: t("All Categories"),
      icon: "icon icon-home",
      url: "/dashboard/allCategories",
      component: AllCategories,
    },
    {
      label: t("Order Management"),
      icon: "icon icon-orderMgmt",
      url: "/dashboard/ordermanagement",
    },
    {
      label: t("View Awards"),
      icon: " icon icon-award",
      url: "/dashboard/ViewAward",
      component: ViewAward,
    },
    {
      label: t("All Bundle"),
      icon: "icon icon-video",
      url: "/dashboard/allbundle",
      component: BundleList,
    },
    {
      label: t("Subscription"),
      icon: "icon icon-courses",
      url: "/dashboard/CurrentSubscription",
      component: Subscription,
    },
  ];

  const adminMenu = [
    {
      label: t("sideMenu.dashboard"),
      icon: "icon icon-home",
      url: "/dashboard",
      component: Dashboard,
    },
    {
      label: t("Instructor List"),
      icon: "icon icon-instructors",
      url: "/dashboard/instructorList",
      component: MemberList,
    },
    {
      label: t("Students List"),
      icon: "icon icon-students",
      url: "/dashboard/studentList",
      component: StudentsList,
    },
    {
      label: t("Quiz Result"),
      icon: " icon icon-award",
      url: "/dashboard/QuizResult",
      component: QuizResult,
    },
    {
      label: t("All Courses"),
      icon: "icon icon-video",
      url: "/dashboard/Course",
      component: CourseList,
    },
    {
      label: t("sideMenu.webinars"),
      icon: "icon icon-video",
      url: "/dashboard/webinars",
      component: WebinarEvents,
    },
    {
      label: t("Create a Bundle"),
      icon: "icon icon-video",
      url: "/dashboard/CreateBundle",
      component: CreateBundle,
    },

    {
      label: "Announcement",
      icon: "icon icon-award",
      url: "/dashboard/Announcement",
      component: Announcement,
    },

    {
      label: t("Reports"),
      icon: "icon icon-courses",
      innerComponents: [
        {
          label: t(" Detail for Student"),
          icon: "icon icon-courses",
          url: "/dashboard/studentdata",
          component: StudentData,
        },
        {
          label: t("Detail  For Courses"),
          icon: "icon icon-courses",
          url: "/dashboard/coursreport",
          component: CourseReport,
        },
        {
          label: t("Month Wise Report"),
          icon: "icon icon-courses",
          url: "/dashboard/monthreport",
          component: MonthReport,
        },
        {
          label: t("Detail For Teachers"),
          icon: "icon icon-courses",
          url: "/dashboard/teacherreport",
          component: TeacherReport,
        },
        {
          label: t("MonthWise Payment Report"),
          icon: "icon icon-courses",
          url: "/dashboard/paymentreport",
          component: PaymentReport,
        },
      ],
    },
    {
      label: t("View Awards"),
      icon: " icon icon-award",
      url: "/dashboard/ViewAward",
      component: ViewAward,
    },
    {
      label: t("All Bundle"),
      icon: "icon icon-video",
      url: "/dashboard/allbundle",
      component: BundleList,
    },
  ];

  const studentMenu = [
    {
      label: t("sideMenu.dashboard"),
      icon: "icon icon-home",
      url: "/dashboard",
      component: Dashboard,
    },
    {
      label: "My Courses",
      key: 1,
      icon: "icon icon-courses",
      url: "/dashboard/courses",
      component: CourseList,
    },
    {
      label: "Available Courses",
      key: 2,
      icon: "icon icon-shoppingCartDark",
      url: "/dashboard/availablecourses",
      component: CoursesContainer,
    },
    // {
    //   label: t("sideMenu.shopCourses"),
    //   key: 2,
    //   icon: "icon icon-shoppingCartDark",
    //   url: "/courses",
    // },
    {
      label: t("sideMenu.myWishlist"),
      key: 3,
      icon: "icon icon-wishlist",
      url: "/dashboard/wishlist",
      component: wishlist,
    },
    {
      key: 4,
      label: t("My Webinars"),
      icon: "icon icon-video",
      url: "/dashboard/webinars",
      component: WebinarEvents,
    },

    {
      key: 7,
      label: t("sideMenu.forum"),
      icon: "icon icon-forum",
      url: "/dashboard/forum",
      component: StudentForum,
    },

    {
      key: 9,
      label: t("sideMenu.announcements"),
      icon: "icon icon-mic",
      url: "/dashboard/announcements",
      component: StudentAnnouncement,
    },
    {
      key: 10,
      label: t("View Awards"),
      icon: " icon icon-award",
      url: "/dashboard/ViewAward",
      component: ViewAward,
    },
    {
      key: 11,
      label: t("Quiz Result"),
      icon: " icon icon-award",
      url: "/dashboard/QuizResult",
      component: QuizResult,
    },
  ];
  const teacherMenu = [
    {
      label: t("sideMenu.dashboard"),
      icon: "icon icon-home",
      url: "/dashboard",
      component: Dashboard,
    },
    {
      label: t("sideMenu.webinars"),
      icon: "icon icon-video",
      url: "/dashboard/webinars",
      component: WebinarEvents,
    },

    {
      label: "Course List",
      icon: "icon icon-courses",
      url: "/dashboard/courses",
      component: CourseList,
    },
    {
      label: t("View Awards"),
      icon: " icon icon-award",
      url: "/dashboard/ViewAward",
      component: ViewAward,
    },
    {
      label: "Announcement",
      icon: "icon icon-award",
      url: "/dashboard/Announcement",
      component: Announcement,
    },
  ];

  const parentsMenu = [
    {
      label: "Dashboard",
      icon: "icon icon-home",
      component: "parent > dashboard",
    },
    {
      label: "Students",
      icon: "icon icon-students",
      component: "parent > Students",
    },
    {
      label: "Reports",
      icon: "icon icon-reports",
      component: "parent > Reports",
    },
    {
      label: "Webinar(s)",
      icon: "icon icon-video",
      component: "parent > Webinars",
    },
    {
      label: "Announcements",
      icon: "icon icon-mic",
      component: "parent > Announcements",
    },
    {
      label: "Forums",
      icon: "icon icon-forum",
      component: "parent > forums",
    },
  ];

  //role 1 for admin
  //role 2 for student
  //role 3 for institute
  //role 4 for instructor
  //role 5 for parent

  switch (user?.role) {
    case 1:
      var sideMenu = adminMenu;
      break;
    case 2:
      var sideMenu = studentMenu;
      break;
    case 3:
      var sideMenu = enterpriseMenu;
      break;
    case 4:
      var sideMenu = teacherMenu;
      break;
    default:
      var sideMenu = studentMenu;
  }

  const showCourseBuilder = (location) => {
    const str = "/dashboard/categories";
    if (location?.pathname.substring(21, 0) === str) {
      return true;
    } else if (
      ["/dashboard/CourseBuilder", "/dashboard/cart"].includes(
        location.pathname.split(/(\/\d+)/)[0]
      )
    ) {
      return true;
    }
  };
  return (
    <>
      <div
        className={`${
          showCourseBuilder(props.location) ? "" : "App back-panel"
        }`}
      >
        {/* <div className="App back-panel"> */}
        <div className="container-dashboard">
          {/* Import Navbar here */}

          {!showCourseBuilder(props.location) && (
            <div className={showIconsOnly ? "left-panel1" : "left-panel"}>
              <div className="logo-wrapper">
                <Link aria-label="Dashboard Home">
                  {showIconsOnly ? "E" : <i className="logo"></i>}
                </Link>

                <div
                  className="abc"
                  onClick={() =>
                    showIconsOnly
                      ? setShowIconsOnly(false)
                      : setShowIconsOnly(true)
                  }
                >
                  <i className="icon icon-burger"></i>
                </div>
              </div>

              <ul key="left-panel" className="dropdownMenu">
                {sideMenu.map((item, key) => {
                  return item.url ? (
                    <li
                      className={
                        window.location.pathname == item.url
                          ? "dropdownItem active"
                          : "dropdownItem"
                      }
                      key={key}
                    >
                      <Link to={item?.url}>
                        {showIconsOnly ? (
                          <i className={item.icon}></i>
                        ) : (
                          <>
                            <i className={item.icon}>
                              {/*<b>{item.icon}</b>*/}
                            </i>

                            <span>{item.label}</span>
                          </>
                        )}
                      </Link>
                    </li>
                  ) : (
                    <>
                      <li
                        className={`dropdownItem ${
                          !dropdownToggle
                            ? "reports-dropdown"
                            : "reports-dropdown-1"
                        }`}
                        onClick={() => setDropdownToggle(!dropdownToggle)}
                        key={key}
                      >
                        <a>
                          {showIconsOnly ? (
                            <i className={item.icon}></i>
                          ) : (
                            <>
                              <i className={item.icon}>
                                {/*<b>{item.icon}</b>*/}
                              </i>

                              <span>{item.label}</span>
                            </>
                          )}
                        </a>
                      </li>
                      <div
                        className={`${
                          !dropdownToggle ? "height-0" : "height-auto"
                        }`}
                      >
                        {item?.innerComponents.map((ele, index) => (
                          <li
                            className={
                              window.location.pathname == ele.url
                                ? "dropdownItem active"
                                : "dropdownItem"
                            }
                            key={index}
                          >
                            <Link to={ele?.url}>
                              {showIconsOnly ? (
                                <i className={ele.icon}></i>
                              ) : (
                                <div>
                                  <i className={`${ele.icon} icon-width`}>
                                    {/*<b>{item.icon}</b>*/}
                                  </i>

                                  <span className="icon-label-new">
                                    {ele.label}
                                  </span>
                                </div>
                              )}
                            </Link>
                          </li>
                        ))}
                      </div>
                    </>
                  );
                })}
              </ul>
              <div className="sidebar-bottom-color">
                <p>Copyright &copy; 2022 Edusity</p>
              </div>
            </div>
          )}

          <div
            key="right-panel"
            className={showIconsOnly ? "right-panel1" : "right-panel"}
          >
            {!showCourseBuilder(props.location) && <Navbar />}

            <Router history={history}>
              <Switch>
                <Route exact path="/dashboard/profile" component={Profile} />
                {/* <Route exact path="/dashboard/categories/:courseId" component={CourseDetail} /> */}
                <Route
                  exact
                  path="/dashboard/categories/:subCategory?/:courseId"
                  component={CourseDetail}
                />
                <Route
                  exact
                  path="/dashboard/CourseBuilder/:id?"
                  component={CourseBuilder}
                />

                <Route
                  exact
                  path="/dashboard/CourseEdit/:id"
                  component={CourseEdit}
                />
                <PrivateRoute path="/dashboard/cart" component={Cart} />
                {/*
              <Route
                exact
                path="/dashboard/create-courses/:id"
                component={CreateCourse}
              />
              <Route
                exact
                path="/dashboard/add-course-section"
                component={CreateCourseSection}
              />

              <Route
                exact
                path="/dashboard/ViewAward"
                component={ViewAward}
              />
              <Route
                exact
                path="/dashboard/QuizResult"
                component={QuizResult}
              />
              <Route
                exact
                path="/dashboard/CurrentSubscription"
                component={CurrentSubscription}
              /> */}

                {sideMenu.map((item, key) => {
                  return item.url ? (
                    <Route
                      exact
                      path={item.url}
                      key={key}
                      component={item.component}
                    />
                  ) : (
                    item.innerComponents.map((ele, index) => (
                      <Route
                        exact
                        path={ele.url}
                        key={index}
                        component={ele.component}
                      />
                    ))
                  );
                })}
                <Route exact component={Error404} />
              </Switch>
            </Router>
          </div>
        </div>
      </div>
      {/* <SessionExpire /> */}
    </>
  );
}
